<template>
    <div class="body-inner">
        <header-component></header-component>
        <!-- DETALLE DE PRODUCTO -->
        <!-- DETALLE DE PRODUCTO -->
        <section id="product-page" class="product-page p-b-0">
            <div class="container">
                <div class="product">
                    <div class="row m-b-40" v-if="model.imagen">
                        <div class="col-lg-2">
                            <div class="product-image">
                                <img :src="model.imagen">
                            </div>
                        </div>
                        <div class="col-lg-10">
                            <div class="product-description">
                                <div class="product-category"></div>
                                <div class="product-title">
                                    <h3>
                                        <a href="#">{{ model.nombre }}</a>
                                    </h3>
                                </div>
                                <div class="product-price"></div>
                                <p>{{ model.descripcion }}</p>
                                <p>Nota: Si tiene cupón de descuento, es necesario anotarlo y validarlo antes de seleccionar las versiones a comprar.</p>
                                <p>Todos los precios precios mostrados son con IVA incluido.</p>
                                <div class="seperator m-t-20 m-b-10"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <input class="form-control" @input="form.codigoCupon = form.codigoCupon.trim().toUpperCase()" placeholder="Cupon de descuento" type="text" name="codigoCupon" id="codigoCupon" v-model="form.codigoCupon">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <button class="btn" @click.prevent="validateCupon">Validar cupón</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <h5>{{ coursesHeader }}</h5>
                                    <div class="table table-sm table-striped table-responsive">
                                        <form>
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th class="cart-product-thumbnail">Producto</th>
                                                        <th class="cart-product-thumbnail">Certificación</th>
                                                        <th class="cart-product-thumbnail">Curso</th>
                                                        <th class="cart-product-thumbnail">Certipack</th>
                                                        <th class="cart-product-price">Precio unitario</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="version in model.versiones" :key="version.id">
                                                        <td>
                                                            <div class="form-check">
                                                                <input class="form-check-input" value="" :id="`check${version.id}`" type="checkbox" @change="enableTipoCompra(version.id)" v-model="version.checked" v-if="version.activo == 1">
                                                                <label class="form-check-label" :for="`check${version.id}`">
                                                                    {{ version.nombre }}
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                            <input class="form-check-input ml-5 none" :name="`tipo_compra${version.id}`" @click="consultaPrecio(version.id, 1)" value="" :id="`tipoCompra${version.id}_1`" type="radio" :disabled="!version.checked">
                                                            <p :id="`prox${version.id}_1`" style="font-size: 0.7rem; font-style: italic;">Próximamente</p>
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                            <input class="form-check-input ml-5 none" :name="`tipo_compra${version.id}`" @click="consultaPrecio(version.id, 2)" value="" :id="`tipoCompra${version.id}_2`" type="radio" :disabled="!version.checked">
                                                            <p :id="`prox${version.id}_2`" style="font-size: 0.7rem; font-style: italic;">Próximamente</p>
                                                        </td>
                                                        <td class="cart-product-thumbnail">
                                                            <input class="form-check-input ml-5 none" :name="`tipo_compra${version.id}`" @click="consultaPrecio(version.id, 3)" value="" :id="`tipoCompra${version.id}_3`" type="radio" :disabled="!version.checked">
                                                            <p :id="`prox${version.id}_3`" style="font-size: 0.7rem; font-style: italic;">Próximamente</p>
                                                        </td>
                                                        <td class="cart-product-subtotal">
                                                            <span class="amount" :id="`precioText${version.id}`">$0.00</span>
                                                            <input type="hidden" :id="`precio${version.id}`"/>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </form>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <h5>Total</h5>
                                    <span class="amount color lead"><strong>{{ new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(form.total) }} MXN</strong></span><br><br>
                                    <button class="btn" @click.prevent="addProductCart"><i class="icon-shopping-cart"></i> Agregar a carrito</button><br>
                                    <router-link class="btn" to="/productos">Regresar al catálogo</router-link>
                                </div>
                            </div>
                            <div class="row">
                                <p v-if="model.clave == 'Autodesk'">
                                    En caso de la version Membresía ATC Level 2 - Main se deben adquirir las opciones A + B para proceder con su trámite.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- end: SHOP PRODUCT PAGE -->
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2020 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from './components/HeaderComponent'
export default {
  name: 'DetalleProducto',
  components: {
    HeaderComponent
  },
  data() {
      return {
        coursesHeader: 'Cursos / Certificaciones disponibles',
        model: {
            imagen: '',
        },
        form: {
            total: 0,
            codigoCupon: '',
        },
        hostname: '',
      }
  },

  methods: {

    consultaPrecio(id_version, tipo) {
        const arrayPrecios = this.model.precios
        const precios = arrayPrecios.filter(precio => precio.id_version == id_version && precio.tipo == tipo)
        const descuento = this.$store.getters.descuento / 100
        let precio = precios[0].precio - (precios[0].precio * (descuento))

        if(this.$store.getters.cupon == 'EXCELEXP') {
            if(precios[0].tipo != 3) {
                
                setTimeout(() => {
                    $("#tipoCompra" + id_version + `_1`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_2`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_3`).prop('checked', false);
                    $("#precio" + id_version).val('')
                }, 100);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certipack", no aplica para "Certificación" ni para "Curso".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                this.calculaPrecio()
                return
            }
        }        

        if(this.$store.getters.cupon == 'MOSJUNIO') {
            if(precios[0].tipo != 1) {

                setTimeout(() => {
                    $("#tipoCompra" + id_version + `_1`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_2`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_3`).prop('checked', false);
                    $("#precio" + id_version).val('')
                }, 100);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certificación", no aplica para "Certipak" ni para "Curso".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                this.calculaPrecio()
                return
            }
        }


        if(this.$store.getters.cupon == '1BCHWRD365') {
            if(precios[0].tipo != 3) {
                
                setTimeout(() => {
                    $("#tipoCompra" + id_version + `_1`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_2`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_3`).prop('checked', false);
                    $("#precio" + id_version).val('')
                }, 100);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certipack", no aplica para "Certificación" ni para "Curso".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                this.calculaPrecio()
                return
            }
        }

        if(this.$store.getters.cupon == '2BCHWRDXLS365') {
            if(precios[0].tipo != 3) {

                setTimeout(() => {
                    $("#tipoCompra" + id_version + `_1`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_2`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_3`).prop('checked', false);
                    $("#precio" + id_version).val('')
                }, 100);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certipack", no aplica para "Certificación" ni para "Curso".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                this.calculaPrecio()
                return
            }
        }

        if(this.$store.getters.cupon == 'XLS365TECMET' || this.$store.getters.cupon == 'XLS365TECTOL') {
            if(precios[0].tipo != 3) {

                setTimeout(() => {
                    $("#tipoCompra" + id_version + `_1`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_2`).prop('checked', false);
                    $("#tipoCompra" + id_version + `_3`).prop('checked', false);
                    $("#precio" + id_version).val('')
                }, 100);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certipack", no aplica para "Certificación" ni para "Curso".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                this.calculaPrecio()
                return
            }
        }

        if(this.$store.getters.cupon == 'CHERBART2223') {
            if(precios[0].tipo != 2) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Curso", no aplica para "Certificación" ni para "Certipack".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                this.calculaPrecio()
                return
            }
        }
        if(this.$store.getters.cupon == 'HAZMASETC') {
            if(this.$store.getters.total === 0)
                this.$store.commit('setPrimerVersion', id_version)
            if(precios[0].tipo != 1) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certificación", no aplica para "Curso" ni para "Certipack".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                // this.calculaPrecio()
                return
            }

            if(this.$store.getters.numProductos === 2) {
                if(this.$store.getters.total > 0 && this.$store.getters.primerVersion !== id_version)
                    precio = 400
            }
            if(this.$store.getters.numProductos === 3)
                precio = 300
        }

        if(this.$store.getters.cupon == 'HAZMASETC-2') {
            if(this.$store.getters.total === 0)
                this.$store.commit('setPrimerVersion', id_version)
            if(precios[0].tipo != 2) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Curso", no aplica para "Certificación" ni para "Certipack".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                // this.calculaPrecio()
                return
            }

            if(this.$store.getters.numProductos === 2 && this.$store.getters.primerVersion !== id_version)
                precio = 600
            if(this.$store.getters.numProductos === 3)
                precio = 800
        }

        if(this.$store.getters.cupon == 'HAZMASETC-3') {
            if(this.$store.getters.total === 0)
                this.$store.commit('setPrimerVersion', id_version)
            if(precios[0].tipo != 3) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de "Certipack", no aplica para "Certificación" ni para "Curso".',
                })
                $("#precio" + id_version).val(0)
                $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                // this.calculaPrecio()
                return
            }

            if(this.$store.getters.numProductos === 2 && this.$store.getters.primerVersion !== id_version)
                precio = 1120
            if(this.$store.getters.numProductos === 3)
                precio = 1160
        }
        
        $("#precio" + id_version).val(precio)
        $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(precio))
        this.calculaPrecio()
    },

    enableTipoCompra(id_version) {
        this.$forceUpdate()


        if(this.$store.getters.cupon == 'EXCELEXP') {
            if(id_version != 200 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Excel Expert Online. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }
        
        if(this.$store.getters.cupon == 'MOSJUNIO') {
            if(id_version != 232 && id_version != 234 && id_version != 235 && id_version != 236 && id_version != 237 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Productos de Office 365. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }


        if(this.$store.getters.cupon == 'ESBCERTIFICA') {
            if(id_version != 56 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Productos ESB. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }


        if(this.$store.getters.cupon == 'PJQMOS') {
            if(id_version != 232 && id_version != 234 && id_version != 235 && id_version != 236 && id_version != 237 && id_version != 54 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Productos de Office 365. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }




        if(this.$store.getters.cupon == '1BCHWRD365') {
            if(id_version != 197 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Word Online. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }

        if(this.$store.getters.cupon == '2BCHWRDXLS365') {
            if(id_version != 197 && id_version != 198 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Word Online y Microsoft Excel Online. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }

        if(this.$store.getters.cupon == 'XLS365TECMET' || this.$store.getters.cupon == 'XLS365TECTOL') {
            if(id_version != 75 && id_version != 198 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Excel 365 y Microsoft Excel Online. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }

        if(this.$store.getters.cupon === 'MOSXLSX') {
            if(id_version != 49 && id_version != 232 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Excel 365 y/o Microsoft Excel 2019. Agrega al carrito la compra que ya está seleccionada con tu cupón de descuento',
                })
                
                return
            }
        }        

        


        if(this.$store.getters.cupon == 'CHERBART2223') {
            if(id_version != 48 && id_version != 49 && $("#check" + id_version).prop('checked') == true) {

                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Word 2019/365 o Microsoft Excel 2019/365.',
                })
                
                return
            }
        }
        if(this.$store.getters.cupon == 'HAZMASETC') {
            const validVersions = [48,49,43,44,45,46,47,10,11,50,51,52,53,54,90,97,98,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185];
            const isValidVersion = validVersions.find( element => element === id_version )
            if($("#check" + id_version).prop('checked') == true)
                this.$store.commit('setNumProductos', 1)
            if($("#check" + id_version).prop('checked') == false) {
                this.$store.commit('setNumProductos', -1)
                setTimeout(() => {
                    $("#precio" + id_version).val(0)
                    $("#precioText" + id_version).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(0))
                }, 100);
            }
            if(this.$store.getters.numProductos > 3) {
                this.$store.commit('setNumProductos', -1)
                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de máximo 3 productos.',
                })
                
                return
            }
            if(isValidVersion === undefined && $("#check" + id_version).prop('checked') == true) {
                this.$store.commit('setNumProductos', -1)
                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Office y/o Adobe.',
                })
                
                return
            }
        }
        if(this.$store.getters.cupon == 'HAZMASETC-2' || this.$store.getters.cupon == 'HAZMASETC-3') {
            const validVersions = [48,49,43,44,45,46,47,10,11,50,51,52,53,54];
            const isValidVersion = validVersions.find( element => element === id_version )
            if($("#check" + id_version).prop('checked') == true)
                this.$store.commit('setNumProductos', 1)
            if($("#check" + id_version).prop('checked') == false)
                this.$store.commit('setNumProductos', -1)
            if(this.$store.getters.numProductos > 3) {
                this.$store.commit('setNumProductos', -1)
                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de máximo 3 productos.',
                })
                
                return
            }
            if(isValidVersion === undefined && $("#check" + id_version).prop('checked') == true) {
                this.$store.commit('setNumProductos', -1)
                setTimeout(() => {
                    $("#check" + id_version).prop('checked', false);
                    $("#tipoCompra" + id_version + `_1`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_2`).prop('disabled', true);
                    $("#tipoCompra" + id_version + `_3`).prop('disabled', true);
                    $("#precio" + id_version).val('')
                }, 100);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'El cupón indicado sólo es válido para la compra de Microsoft Office.',
                })
                
                return
            }
        }

        const precios = this.model.precios.filter(precio => precio.id_version == id_version)
        if($("#check" + id_version).prop('checked') != true)
            $("#precio" + id_version).val('')
        else {
            for (let index = 1; index <= 3; index++) {
                if($("#tipoCompra" + id_version + `_${index}`).is(':checked') == true) {
                    this.consultaPrecio(id_version, index)
                }
            }
        }

        this.calculaPrecio()
    },

    calculaPrecio() {
        const versiones = this.model.versiones
        let total = 0
        let selected = 0
        versiones.forEach((element) => {
            if($("#precio" + element.id).val() != '' && $("#check" + element.id).prop('checked') == true){
                selected ++
                if(selected == 1) {
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC') {
                        $("#precio" + element.id).val(800)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(800))
                    }

                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC-2') {
                        $("#precio" + element.id).val(900)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(900))
                    }

                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC-3') {
                        $("#precio" + element.id).val(1200)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(1200))
                    }
                }
                if(selected == 2) {
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC') {
                        $("#precio" + element.id).val(400)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(400))
                    }
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC-2') {
                        $("#precio" + element.id).val(600)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(600))
                    }
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC-3') {
                        $("#precio" + element.id).val(1120)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(1120))
                    }
                }
                if(selected == 3) {
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC') {
                        $("#precio" + element.id).val(300)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(300))
                    }
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC-2') {
                        $("#precio" + element.id).val(800)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(800))
                    }
                    if(this.$store.getters.cupon.toUpperCase() == 'HAZMASETC-3') {
                        $("#precio" + element.id).val(1160)
                        $("#precioText" + element.id).text(new Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(1160))
                    }
                }
                
                // if(this.$store.getters.cupon.toUpperCase() != 'HAZMASETC')
                total = total + parseFloat($("#precio" + element.id).val())
            }
        })

        this.form.total = total
        this.$store.commit("setTotal", (total))
    },

    addProductCart() {
        if(this.form.total == 0){
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Debe seleccionar al menos una versión para activar.',
            })
            return 
        }
        if(this.$store.getters.cupon == 'CHERBART2223') {
            const checkTotal = parseFloat(this.form.total.toFixed(2));
            if(checkTotal != 740) {
               Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Debe seleccionar los productos Microsoft Word 2019/365 y Microsoft Excel 2019/365 para hacer válido el cupon de descuento.',
                })

                return
            }
            this.form.total = checkTotal
        }
        const versiones = this.model.versiones
        let producto = {
            id_producto: this.model.id,
            nombre: this.model.nombre,
            cantidad: 1,
            versiones: [],
            total: this.form.total
        }

        versiones.forEach((element) => {
            let tipoCompra = ''
            if($('#check' + element.id).is(':checked') == true) {
                for (let index = 1; index <= 3; index++) {
                    if($("#tipoCompra" + element.id + `_${index}`).is(':checked') == true) {
                        if(index == 1)
                            tipoCompra = 'Certificación'
                        if(index == 2)
                            tipoCompra = 'Sólo curso'
                        if(index == 3)
                            tipoCompra = 'Combo'
                        producto.versiones.push({
                            id_version: element.id,
                            nombre: element.nombre,
                            tipo_compra: index,
                            tipoCompra: tipoCompra,
                            cantidad: 1,
                            precio: parseFloat($("#precio" + element.id).val()),
                            subtotal: parseFloat($("#precio" + element.id).val()),
                        })
                    }
                }
                
            }
        })
        this.$store.commit('addProduct', producto)

        //verificamos si el usuario está logueado
        if(this.$store.getters.usuario) {
            this.saveDataNoForm('api/carrito', producto, '', '', null, 0, 0, null)
        }

        Toast.fire({
            icon: 'success',
            title: 'Producto agregado al carrito.'
        })
    },

    async validateCupon() {
        if(this.form.codigoCupon != '') {
            await this.register('api/valida-cupon', { codigoCupon: this.form.codigoCupon }, '', '', null, 0, 1, null)
        } else {
            Toast.fire({
                icon: 'error',
                title: 'Debe de colocar un cupón.'
            })
        }

        console.log('Datos: ' + this.$store.getters.cupon);

        if(this.$store.getters.cupon == 'XLS365TECMET' || this.$store.getters.cupon == 'XLS365TECTOL'){
            setTimeout(() => {
                $("#check232").prop('checked', true);
                $("#check198").prop('checked', true);
                $("#check232").prop('disabled', true);
                $("#check198").prop('disabled', true);
                $("#tipoCompra232_3").prop('disabled', true);
                $("#tipoCompra232_3").prop('checked', true);
                $("#tipoCompra198_3").prop('disabled', true);
                $("#tipoCompra198_3").prop('checked', true);
                $("#precio232").val(400);
                $("#precio198").val(400);
                $("#precioText232").text('$400.00');
                $("#precioText198").text('$400.00');

                this.form.total = 800
                this.$store.commit("setTotal", (800))
            }, 100);

        }

        if(this.$store.getters.cupon == '2BCHWRDXLS365'){
            setTimeout(() => {
                $("#check197").prop('checked', true);
                $("#check198").prop('checked', true);
                $("#check197").prop('disabled', true);
                $("#check198").prop('disabled', true);
                $("#tipoCompra197_3").prop('disabled', true);
                $("#tipoCompra197_3").prop('checked', true);
                $("#tipoCompra198_3").prop('disabled', true);
                $("#tipoCompra198_3").prop('checked', true);
                $("#precio197").val(590);
                $("#precio198").val(590);
                $("#precioText197").text('$590.00');
                $("#precioText198").text('$590.00');

                this.form.total = 1180
                this.$store.commit("setTotal", (1180))
            }, 100);

            setTimeout(() => {
                $("#check92").prop('checked', true);
                $("#check93").prop('checked', true);
                $("#check92").prop('disabled', true);
                $("#check93").prop('disabled', true);
                $("#tipoCompra92_3").prop('disabled', true);
                $("#tipoCompra92_3").prop('checked', true);
                $("#tipoCompra93_3").prop('disabled', true);
                $("#tipoCompra93_3").prop('checked', true);
                $("#precio92").val(590);
                $("#precio93").val(590);
                $("#precioText92").text('$590.00');
                $("#precioText93").text('$590.00');

                this.form.total = 1180
                this.$store.commit("setTotal", (1180))
            }, 100);            
        }

        if(this.$store.getters.cupon == '1BCHWRD365'){
            setTimeout(() => {
                $("#check197").prop('checked', true);
                $("#check197").prop('disabled', true);
                $("#tipoCompra197_3").prop('checked', true);
                $("#tipoCompra197_3").prop('disabled', true);
                $("#precio197").val(750);
                $("#precioText197").text('$750.00');

                this.form.total = 750
                this.$store.commit("setTotal", (750))
            }, 100);

            setTimeout(() => {
                $("#check92").prop('checked', true);
                $("#check92").prop('disabled', true);
                $("#tipoCompra92_3").prop('checked', true);
                $("#tipoCompra92_3").prop('disabled', true);
                $("#precio92").val(750);
                $("#precioText92").text('$750.00');

                this.form.total = 750
                this.$store.commit("setTotal", (750))
            }, 100);

            
        }

        if(this.$store.getters.cupon == 'EXCELEXP'){
            console.log('Cupon de EXCELEXP');
            setTimeout(() => {
                $("#check200").prop('checked', true);
                $("#check200").prop('disabled', true);
                $("#tipoCompra200_3").prop('checked', true);
                $("#tipoCompra200_3").prop('disabled', true);
                $("#precio200").val(800);
                $("#precioText200").text('$800.00');

                this.form.total = 800
                this.$store.commit("setTotal", (800))
            }, 100);

            setTimeout(() => {
                $("#check92").prop('checked', true);
                $("#check92").prop('disabled', true);
                $("#tipoCompra92_3").prop('checked', true);
                $("#tipoCompra92_3").prop('disabled', true);
                $("#precio92").val(800);
                $("#precioText92").text('$800.00');

                this.form.total = 800
                this.$store.commit("setTotal", (800))
            }, 100);

            
        }        
    },

    configColumnas() {
        const precios = this.model.precios
        const versiones = this.model.versiones

        precios.forEach(precio => {
            $(`#tipoCompra${precio.id_version}_${precio.tipo}`).removeClass('none')
            $(`#prox${precio.id_version}_${precio.tipo}`).addClass('none')
        })
    }
  },
  async mounted() {
      this.hostname = hostname
    const script = document.createElement('script')
    script.src = '/js/functions.js'
    script.id = 'functionScript'
    document.body.appendChild(script)

    await this.loadData(`api/productos/${this.$route.params.id}`)

    if(this.model.clave == 'Autodesk')
        this.coursesHeader = 'Cursos / Certificaciones disponibles Autodesk 2019/2020 ACU 2021*'

    this.configColumnas()

    if(this.$store.getters.cupon == 'HAZMASETC' || this.$store.getters.cupon == 'HAZMASETC-2' || this.$store.getters.cupon == 'HAZMASETC-3') {
        this.$store.commit('setNumProductos', 0)
        this.$store.commit('setPrimerVersion', 0)
    }
  },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
<style>
    .none{
        display: none;
    }
</style>